// A2 - Final Sınavı
// Kapsamlı final sınavı - Tüm A2 konuları (Ünite sınavlarından FARKLI sorular)

export const A2_FINAL = {
  'A2-FINAL': {
    id: 'A2-FINAL',
    title: 'A2 Final Sınavı',
    type: 'exam',
    exercises: [
      // Past Simple (FARKLI SORULAR)
      {
        type: 'multipleChoice',
        question: 'The flight _____ delayed due to bad weather.',
        options: ['was', 'were', 'is', 'be'],
        correct: 'was',
        explanation: 'The flight (tekil) ile was'
      },
      {
        type: 'multipleChoice',
        question: 'We _____ to New York last month. (go)',
        options: ['went', 'goed', 'go', 'gone'],
        correct: 'went',
        explanation: 'go → went (düzensiz)'
      },
      {
        type: 'multipleChoice',
        question: "The crew _____ any problems during the flight.",
        options: ["didn't have", "didn't had", "not have", "doesn't have"],
        correct: "didn't have",
        explanation: "didn't + fiil kök hali"
      },
      {
        type: 'multipleChoice',
        question: '_____ the passengers arrive on time?',
        options: ['Did', 'Do', 'Were', 'Was'],
        correct: 'Did',
        explanation: 'Geçmiş zaman sorusu: Did'
      },
      // Future (FARKLI SORULAR)
      {
        type: 'multipleChoice',
        question: 'We _____ land in 20 minutes.',
        options: ['will', 'going to', 'are', 'were'],
        correct: 'will',
        explanation: 'Gelecek zaman: will + fiil'
      },
      {
        type: 'multipleChoice',
        question: 'I _____ become a senior flight attendant. (plan)',
        options: ['am going to', 'will going to', 'going to', 'am go to'],
        correct: 'am going to',
        explanation: 'Plan: I am going to + fiil'
      },
      // Comparatives & Superlatives (FARKLI SORULAR)
      {
        type: 'multipleChoice',
        question: 'Economy class is _____ than business class. (cheap)',
        options: ['cheaper', 'more cheap', 'cheapest', 'cheap'],
        correct: 'cheaper',
        explanation: 'Comparative: cheaper'
      },
      {
        type: 'multipleChoice',
        question: 'Emirates is one of _____ airlines. (famous)',
        options: ['the most famous', 'the famouser', 'the more famous', 'famous'],
        correct: 'the most famous',
        explanation: 'Superlative: the most famous'
      },
      // Modal Verbs (FARKLI SORULAR)
      {
        type: 'multipleChoice',
        question: 'All crew members _____ wear uniforms. (zorunlu)',
        options: ['must', 'should', 'can', 'might'],
        correct: 'must',
        explanation: 'Zorunluluk = must'
      },
      {
        type: 'multipleChoice',
        question: "You _____ use electronic devices during takeoff. (yasak)",
        options: ["mustn't", "shouldn't", "don't have to", "must"],
        correct: "mustn't",
        explanation: "Yasak = mustn't"
      },
      {
        type: 'multipleChoice',
        question: 'Candidates _____ prepare for the interview. (tavsiye)',
        options: ['should', 'must', 'have to', 'will'],
        correct: 'should',
        explanation: 'Tavsiye = should'
      },
      // Fill in the blank
      {
        type: 'fillInBlank',
        sentence: 'The captain _____ (make) an announcement.',
        answer: 'made',
        hint: 'make → made'
      },
      {
        type: 'fillInBlank',
        sentence: 'They _____ (be going to / serve) dinner soon.',
        answer: 'are going to serve',
        hint: 'They are going to + fiil'
      },
      {
        type: 'fillInBlank',
        sentence: 'First class is _____ (expensive) than economy.',
        answer: 'more expensive',
        hint: 'Comparative: more expensive'
      },
      // Matching
      {
        type: 'matchPairs',
        instruction: 'Düzensiz fiilleri eşleştirin',
        pairs: [
          { left: 'take', right: 'took' },
          { left: 'make', right: 'made' },
          { left: 'come', right: 'came' },
          { left: 'get', right: 'got' }
        ]
      },
      {
        type: 'matchPairs',
        instruction: 'Karşılaştırma yapılarını eşleştirin',
        pairs: [
          { left: 'big', right: 'bigger' },
          { left: 'important', right: 'more important' },
          { left: 'good', right: 'better' },
          { left: 'bad', right: 'worse' }
        ]
      }
    ]
  }
};

export default A2_FINAL;
